import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold mb-4" }, "Firmendaten", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Firmendaten")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-lg-6 mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }, " Stammdaten ", -1)
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = { class: "col-3 col-form-label" }
const _hoisted_13 = { class: "col-9 col-form-label" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = { class: "col-3 col-form-label" }
const _hoisted_16 = { class: "col-9 col-form-label" }
const _hoisted_17 = { class: "form-group row" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "Herr" }, "Herr", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "Frau" }, "Frau", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "Firma" }, "Firma", -1)
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = { class: "col-md-9" }
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = { class: "invalid-feedback" }
const _hoisted_30 = { class: "form-group row" }
const _hoisted_31 = { class: "col-md-9" }
const _hoisted_32 = { class: "invalid-feedback" }
const _hoisted_33 = { class: "form-group row" }
const _hoisted_34 = { class: "col-md-9" }
const _hoisted_35 = { class: "invalid-feedback" }
const _hoisted_36 = { class: "col-12 col-lg-6 mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }, " Anschrift ", -1)
const _hoisted_38 = { class: "form-group row" }
const _hoisted_39 = { class: "col-md-9" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-8" }
const _hoisted_42 = { class: "invalid-feedback" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "invalid-feedback" }
const _hoisted_45 = { class: "form-group row" }
const _hoisted_46 = { class: "col-md-9" }
const _hoisted_47 = { class: "invalid-feedback" }
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = { class: "col-md-9" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-5" }
const _hoisted_52 = { class: "invalid-feedback" }
const _hoisted_53 = { class: "col-md-7" }
const _hoisted_54 = { class: "invalid-feedback" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "errorMsg" }, null, -1)
const _hoisted_56 = { class: "form-group row" }
const _hoisted_57 = { class: "col-md-9" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "invalid-feedback" }
const _hoisted_60 = { class: "col-12 col-lg-6 mb-3" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }, " Hauptansprechpartner für den Kundenaccount ", -1)
const _hoisted_62 = { class: "form-group row" }
const _hoisted_63 = { class: "col-md-9" }
const _hoisted_64 = { class: "input-group" }
const _hoisted_65 = { class: "input-group-append" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-block float-right" }, "Suchen", -1)
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = { class: "invalid-feedback" }
const _hoisted_70 = { class: "form-group row" }
const _hoisted_71 = { class: "col-md-9" }
const _hoisted_72 = { class: "input-group" }
const _hoisted_73 = { class: "invalid-feedback" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cross2" }, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "p-3 d-flex flex-column flex-fill overflow-hidden" }
const _hoisted_77 = { class: "form-group flex-0 mr-5" }
const _hoisted_78 = {
  key: 0,
  class: "alert alert-white"
}
const _hoisted_79 = { class: "media-list media-list-linked media-list-bordered flex-fill overflow-auto" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn bg-transparent rounded-pill border-2 btn-icon ml-1 mr-1 ml-md-3 mr-md-3"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user" })
  ])
], -1)
const _hoisted_82 = { class: "media-body overflow-hidden d-flex flex-column flex-md-row flex-wrap" }
const _hoisted_83 = { class: "mr-3 text-wrap" }
const _hoisted_84 = { class: "text-muted text-opac-right float-left w-100" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_86 = { class: "form-group row" }
const _hoisted_87 = { class: "col-md-9" }
const _hoisted_88 = { class: "invalid-feedback" }
const _hoisted_89 = { class: "form-group row" }
const _hoisted_90 = { class: "col-md-9" }
const _hoisted_91 = { class: "invalid-feedback" }
const _hoisted_92 = { class: "card-footer text-right" }
const _hoisted_93 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.frmCompany.kid.name), 1),
                  _createElementVNode("label", _hoisted_13, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.frmCompany.kid.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.frmCompany.accountType.name), 1),
                  _createElementVNode("label", _hoisted_16, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.frmCompany.accountType.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.salutation.error}])
                  }, _toDisplayString(_ctx.frmCompany.salutation.name), 3),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("select", {
                      tabindex: "2",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.salutation.error}]),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frmCompany.salutation.value) = $event)),
                      disabled: ""
                    }, _hoisted_22, 2), [
                      [_vModelSelect, _ctx.frmCompany.salutation.value]
                    ]),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.frmCompany.salutation.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.title.error}])
                  }, _toDisplayString(_ctx.frmCompany.title.name), 3),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "2",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.title.error}]),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.frmCompany.title.value) = $event)),
                      readonly: ""
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.title.value]
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.frmCompany.title.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.company.error}])
                  }, _toDisplayString(_ctx.frmCompany.company.name), 3),
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "3",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.company.error}]),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.frmCompany.company.value) = $event)),
                      readonly: ""
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.company.value]
                    ]),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.frmCompany.company.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.firstName.error}])
                  }, _toDisplayString(_ctx.frmCompany.firstName.name), 3),
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "4",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.firstName.error}]),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.frmCompany.firstName.value) = $event)),
                      readonly: ""
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.firstName.value]
                    ]),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.frmCompany.firstName.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.lastName.error}])
                  }, _toDisplayString(_ctx.frmCompany.lastName.name), 3),
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "5",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.lastName.error}]),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frmCompany.lastName.value) = $event)),
                      readonly: ""
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.lastName.value]
                    ]),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.frmCompany.lastName.error), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.houseNumber.error||_ctx.frmCompany.street.error}])
                  }, _toDisplayString(_ctx.frmCompany.street.name) + ", " + _toDisplayString(_ctx.frmCompany.houseNumber.name), 3),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          tabindex: "6",
                          class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.street.error}]),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.frmCompany.street.value) = $event)),
                          readonly: ""
                        }, null, 2), [
                          [_vModelText, _ctx.frmCompany.street.value]
                        ]),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.frmCompany.street.error), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          tabindex: "7",
                          class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.houseNumber.error}]),
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.frmCompany.houseNumber.value) = $event)),
                          readonly: ""
                        }, null, 2), [
                          [_vModelText, _ctx.frmCompany.houseNumber.value]
                        ]),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.frmCompany.houseNumber.error), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.additionalAddress.error}])
                  }, _toDisplayString(_ctx.frmCompany.additionalAddress.name), 3),
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "8",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.additionalAddress.error}]),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.frmCompany.additionalAddress.value) = $event)),
                      readonly: ""
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.additionalAddress.value]
                    ]),
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.frmCompany.additionalAddress.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.zipCode.error||_ctx.frmCompany.city.error}])
                  }, _toDisplayString(_ctx.frmCompany.zipCode.name) + ", " + _toDisplayString(_ctx.frmCompany.city.name), 3),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          tabindex: "9",
                          class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.zipCode.error}]),
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.frmCompany.zipCode.value) = $event)),
                          readonly: ""
                        }, null, 2), [
                          [_vModelText, _ctx.frmCompany.zipCode.value]
                        ]),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.frmCompany.zipCode.error), 1)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          tabindex: "10",
                          class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.city.error}]),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.frmCompany.city.value) = $event)),
                          readonly: ""
                        }, null, 2), [
                          [_vModelText, _ctx.frmCompany.city.value]
                        ]),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.frmCompany.city.error), 1)
                      ])
                    ]),
                    _hoisted_55
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.country.error}])
                  }, _toDisplayString(_ctx.frmCompany.country.name), 3),
                  _createElementVNode("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("select", {
                      tabindex: "11",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.country.error}]),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.frmCompany.country.value) = $event)),
                      disabled: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: country.code
                        }, _toDisplayString(country.name), 9, _hoisted_58))
                      }), 128))
                    ], 2), [
                      [_vModelSelect, _ctx.frmCompany.country.value]
                    ]),
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.frmCompany.country.error), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.ansprechpartner.error}])
                  }, _toDisplayString(_ctx.frmCompany.ansprechpartner.name), 3),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        tabindex: "19",
                        class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.ansprechpartner.error}]),
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.frmCompany.ansprechpartner.value) = $event))
                      }, null, 2), [
                        [_vModelText, _ctx.frmCompany.ansprechpartner.value]
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-secondary btn-block",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
                        }, _hoisted_68)
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.frmCompany.ansprechpartner.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.phone.error}])
                  }, _toDisplayString(_ctx.frmCompany.phone.name), 3),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        tabindex: "16",
                        class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.phone.error}]),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.frmCompany.phone.value) = $event))
                      }, null, 2), [
                        [_vModelText, _ctx.frmCompany.phone.value]
                      ]),
                      _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.frmCompany.phone.error), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown-box flex-column overflow-hidden", { 'show d-flex':_ctx.showDropdown }])
                    }, [
                      _createElementVNode("button", {
                        class: "btn-close btn btn-icon",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["prevent"]))
                      }, _hoisted_75),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.searchEmployees && _ctx.searchEmployees(...args))),
                            placeholder: "Suche nach Name / Vorname / Email ..",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.search) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.search]
                          ])
                        ]),
                        (_ctx.users.length <= 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, "Keine Ergbnisse"))
                          : _createCommentVNode("", true),
                        _createElementVNode("ul", _hoisted_79, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: ""
                            }, [
                              _createElementVNode("a", {
                                class: "media cursor-pointer align-items-center",
                                onClick: ($event: any) => (_ctx.chooseEmployee(user))
                              }, [
                                _hoisted_81,
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("span", _hoisted_83, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                                  _createElementVNode("div", _hoisted_84, _toDisplayString(user.email), 1)
                                ]),
                                _hoisted_85
                              ], 8, _hoisted_80)
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.mobil.error}])
                  }, _toDisplayString(_ctx.frmCompany.mobil.name), 3),
                  _createElementVNode("div", _hoisted_87, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "19",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.mobil.error}]),
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.frmCompany.mobil.value) = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.mobil.value]
                    ]),
                    _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.frmCompany.mobil.error), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-md-3 col-form-label", {'text-danger':_ctx.frmCompany.email.error}])
                  }, _toDisplayString(_ctx.frmCompany.email.name), 3),
                  _createElementVNode("div", _hoisted_90, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      tabindex: "22",
                      class: _normalizeClass(["form-control", {'is-invalid':_ctx.frmCompany.email.error}]),
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.frmCompany.email.value) = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.frmCompany.email.value]
                    ]),
                    _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.frmCompany.email.error), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveCompany && _ctx.saveCompany(...args))),
              disabled: !_ctx.userRights.company?.write
            }, "Firmendaten speichern", 8, _hoisted_93)
          ])
        ])
      ])
    ])
  ]))
}